var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 62,
    viewBox: "0 0 67 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7667 28.1667V11.7282L49.1333 6.51673V28.1667H46.9V3.6H20.1V28.1667H17.8667V14.7667H15.6333V6.95H11.1667V0.25H8.93333V6.95H4.46667V14.7667H2.23333V28.1667H0V59.4333H20.1V61.6667H46.9V59.4333H67V28.1667H64.7667ZM6.7 9.18333H13.4V14.7667H6.7V9.18333ZM4.46667 17H15.6333V28.1667H4.46667V17ZM20.1 57.2H2.23333V30.4H20.1V57.2ZM35.7333 59.4333H31.2667V48.2667H35.7333V59.4333ZM44.6667 59.4333H37.9667V46.0333H29.0333V59.4333H22.3333V5.83333H44.6667V59.4333ZM51.3667 9.6166L62.5333 13.3384V28.1667H60.3V14.7667H58.0667V28.1667H55.8333V14.7667H53.6V28.1667H51.3667V9.6166ZM58.0667 57.2H53.6V52.7333H58.0667V57.2ZM64.7667 57.2H60.3V50.5H51.3667V57.2H46.9V30.4H64.7667V57.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8668 32.6333H4.4668V34.8666H17.8668V32.6333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8668 37.1001H4.4668V39.3334H17.8668V37.1001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8668 41.5664H4.4668V43.7997H17.8668V41.5664Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8668 46.0332H4.4668V48.2665H17.8668V46.0332Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6836 10.2998V16.9998H32.3836V10.2998H25.6836ZM30.1503 14.7665H27.9169V12.5331H30.1503V14.7665Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6172 10.2998V16.9998H41.3172V10.2998H34.6172ZM39.0839 14.7665H36.8505V12.5331H39.0839V14.7665Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6836 19.2334V25.9334H32.3836V19.2334H25.6836ZM30.1503 23.7001H27.9169V21.4667H30.1503V23.7001Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6172 19.2334V25.9334H41.3172V19.2334H34.6172ZM39.0839 23.7001H36.8505V21.4667H39.0839V23.7001Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6836 28.1665V34.8665H32.3836V28.1665H25.6836ZM30.1503 32.6332H27.9169V30.3998H30.1503V32.6332Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6172 28.1665V34.8665H41.3172V28.1665H34.6172ZM39.0839 32.6332H36.8505V30.3998H39.0839V32.6332Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6836 37.1001V43.8001H32.3836V37.1001H25.6836ZM30.1503 41.5668H27.9169V39.3334H30.1503V41.5668Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6172 37.1001V43.8001H41.3172V37.1001H34.6172ZM39.0839 41.5668H36.8505V39.3334H39.0839V41.5668Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3661 32.6333H49.1328V34.8666H51.3661V32.6333Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0663 32.6333H53.5996V34.8666H58.0663V32.6333Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5341 32.6333H60.3008V34.8666H62.5341V32.6333Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3661 37.1001H49.1328V39.3334H51.3661V37.1001Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0663 37.1001H53.5996V39.3334H58.0663V37.1001Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5341 37.1001H60.3008V39.3334H62.5341V37.1001Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3661 41.5664H49.1328V43.7997H51.3661V41.5664Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0663 41.5664H53.5996V43.7997H58.0663V41.5664Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5341 41.5664H60.3008V43.7997H62.5341V41.5664Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3661 46.0332H49.1328V48.2665H51.3661V46.0332Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0663 46.0332H53.5996V48.2665H58.0663V46.0332Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5341 46.0332H60.3008V48.2665H62.5341V46.0332Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingWhiteIcon);
export default __webpack_public_path__ + "static/media/BuildingWhiteIcon.af9dc6025e70a5afb3e2e224c5744584.svg";
export { ForwardRef as ReactComponent };